// Runtime helpers for the page-length wave: clearance mask over text blocks,
// progressive draw on scroll. Ported from the design prototype.
const NS = 'http://www.w3.org/2000/svg'

// Every text block's bounding box becomes a blurred black rect in the SVG mask,
// so the line fades out behind text instead of crossing it.
export const buildWaveMask = () => {
    const svg = document.getElementById('ob-wave')
    const shell = document.getElementById('ob-shell')
    const holes = document.getElementById('ob-wave-holes')
    if (!svg || !shell || !holes) return
    // ~220 blurred mask rects are too heavy for mobile GPUs — below 768px the
    // wave runs at reduced opacity with no clearance mask instead (the handoff's
    // sanctioned simplification).
    if (window.innerWidth < 768) {
        holes.textContent = ''
        return
    }
    const box = svg.getBoundingClientRect()
    if (!box.width || !box.height) return
    const originX = box.left + window.scrollX
    const originY = box.top + window.scrollY
    const sx = 1000 / box.width
    const sy = 6000 / box.height
    const seen: string[] = []
    const frag = document.createDocumentFragment()
    shell.querySelectorAll('h1,h2,h3,p,span,a,button,label,input,li,div').forEach((el) => {
        if (el.closest('#ob-wave') || el.closest('#ob-blooms')) return
        const txt = (el.textContent || '').trim()
        if (!txt || txt.length < 2) return
        if (el.children.length && el.matches('div,span,a,button,label')) return
        const r = el.getBoundingClientRect()
        if (!r.width || !r.height || r.height > 400) return
        const key = Math.round(r.left) + ':' + Math.round(r.top + window.scrollY) + ':' + Math.round(r.width)
        if (seen.indexOf(key) > -1) return
        seen.push(key)
        const padX = 14
        const padY = 10
        const rect = document.createElementNS(NS, 'rect')
        rect.setAttribute('x', ((r.left + window.scrollX - originX - padX) * sx).toFixed(1))
        rect.setAttribute('y', ((r.top + window.scrollY - originY - padY) * sy).toFixed(1))
        rect.setAttribute('width', Math.max(1, (r.width + padX * 2) * sx).toFixed(1))
        rect.setAttribute('height', Math.max(1, (r.height + padY * 2) * sy).toFixed(1))
        rect.setAttribute('rx', '8')
        rect.setAttribute('fill', 'black')
        frag.appendChild(rect)
    })
    holes.textContent = ''
    holes.appendChild(frag)
}

// The line draws itself as you descend: dashoffset tied to scroll position.
export const setupWaveDraw = (): (() => void) | null => {
    const path = document.getElementById('ob-wave-path') as SVGPathElement | null
    if (!path) return null
    let len = 0
    try { len = path.getTotalLength() } catch { return null }
    if (!len) return null
    path.style.strokeDasharray = String(len)
    let raf = 0
    const onScroll = () => {
        if (raf) return
        raf = requestAnimationFrame(() => {
            raf = 0
            const max = (document.documentElement.scrollHeight - window.innerHeight) || 1
            const p = Math.min(1, Math.max(0, window.scrollY / max))
            path.style.strokeDashoffset = String(len * (1 - (0.18 + 0.82 * p)))
        })
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => {
        window.removeEventListener('scroll', onScroll)
        if (raf) cancelAnimationFrame(raf)
    }
}
